import React from "react";
import Layout from "../../Layout";
import HeaderReports from "../HeaderReports";
import ListMessageSent from "./ListMessageSent";
import GuideMessageStatus from "../MessageStatus/GuideMessageStatus";
import SearchSentMessage from "./SearchSentMessage";

const SentMessage = () => {
  return (
    <Layout>
      <HeaderReports />
      <ListMessageSent />
      <GuideMessageStatus />
      <SearchSentMessage />
    </Layout>
  );
};

export default SentMessage;
